module.exports = __webpack_public_path__ + "static/img/bus.780cfe2f.svg";